export const ORDER_CREATE_REQUEST = "ORDER_CREATE_REQUEST";
export const ORDER_CREATE_SUCCESS = "ORDER_CREATE_SUCCESS";
export const ORDER_CREATE_FAIL = "ORDER_CREATE_FAIL";
export const ORDER_CREATE_RESET = "ORDER_CREATE_RESET";

export const LIST_USER_ORDER_REQUEST = "LIST_USER_ORDER_REQUEST";
export const LIST_USER_ORDER_SUCCESS = "LIST_USER_ORDER_SUCCESS";
export const LIST_USER_ORDER_FAIL = "LIST_USER_ORDER_FAIL";

export const ORDER_DETAILS_REQUEST = "ORDER_DETAILS_REQUEST";
export const ORDER_DETAILS_SUCCESS = "ORDER_DETAILS_SUCCESS";
export const ORDER_DETAILS_FAIL = "ORDER_DETAILS_FAIL";

export const ORDER_PAY_REQUEST = "ORDER_PAY_REQUEST";
export const ORDER_PAY_SUCCESS = "ORDER_PAY_SUCCESS";
export const ORDER_PAY_FAIL = "ORDER_PAY_FAIL";
export const ORDER_PAY_RESET = "ORDER_PAY_RESET";

export const MARK_ORDER_PAID_REQUEST = "MARK_ORDER_PAID_REQUEST";
export const MARK_ORDER_PAID_SUCCESS = "MARK_ORDER_PAID_SUCCESS";
export const MARK_ORDER_PAID_FAIL = "MARK_ORDER_PAID_FAIL";
